import React, {ReactNode} from "react";
import cx from "classnames";

export function FilterModalFieldLabel(props: { children: ReactNode, inLine?: boolean, className?: string }) {
    // return <label className="text-sm font-semibold mb-2">{props.children}</label>
    return <label
        className={cx("font-semibold", !props.className?.includes("text-") && "text-sm", props.inLine && "inline-block w-fit mr-2", !props.inLine && "mb-2", props.className)}>{props.children}</label>
}